import React, { useEffect, useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { authenticateWithMagicLink, saveTokenData } from '../../shared/services/auth/AuthService';
import { useAuth } from '../../shared/contexts/auth/AuthContext';
import { PROJECTS, PROJECTS_ADD } from '../../shared/routes/path';
import { getAuthConfig } from '../signup/services/SignupService';
import FingerprintJS from '@fingerprintjs/fingerprintjs';

const MagicLoginPage: React.FC = () => {
  const { token } = useParams<{ token: string }>();
  const navigate = useNavigate();
  const { login } = useAuth();
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    if (!token) {
      setError('Invalid magic link.');
      return;
    }

    const authenticate = async () => {
      let fingerprint: string | undefined;
      try {
        const config = await getAuthConfig();
        if (config.data.fingerprintProtection) {
          const fp = await FingerprintJS.load();
          const result = await fp.get();
          fingerprint = result.visitorId;
        }
      } catch {}

      try {
        const tokenData = await authenticateWithMagicLink(token, fingerprint);
        login(tokenData);
        navigate(tokenData.isNewAccount ? PROJECTS_ADD : PROJECTS);
      } catch {
        setError('This magic link is invalid or has expired. Please request a new one.');
      }
    };

    authenticate();
  }, [token]);

  if (error) {
    return (
      <div className="auth-pages">
        <div className="auth-pages__right">
          <div className="form-box">
            <div className="form-box__title">Login failed</div>
            <p>{error}</p>
            <a href="/login">Back to login</a>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="auth-pages">
      <div className="auth-pages__right">
        <div className="form-box">
          <div className="form-box__title">Logging you in...</div>
          <p>Please wait while we verify your magic link.</p>
        </div>
      </div>
    </div>
  );
};

export default MagicLoginPage;